console.log('✅ basic-listing-card.js loaded successfully!');

import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { APP_CONFIG } from '../../js/config.js';

export async function buildComponentBasicListingCard(
  buyingCompanyID,
  listingID,
  skuid,
  name,
  link,
  image1FileName,
  price,
  abvSingle,
  moq,
  isProducer,
  customerRating,
  productCardType
) {
  // console.log(`🔄 Building Component: BasicProductCard - Product Name: ${name}`);

  try {
    let html = '';

    // Check if loading state is enabled
    if (productCardType === 'Lazy') {
      html = `
              <div class="FeaturedHomePageProducts" role="img" aria-label="${name}">
                <div class="my-fake-image-height-400">
                    <div class="my-site-lazy-loading-card-darker">
                        <div class="my-site-lazy-loading-card-movement"></div>
                    </div>
                </div>
                 </div>
            `;
    } else {
      // Check if loading state is enabled

      const builtRatingStars = renderStarRating(customerRating);

      html = `
                 <div class="FeaturedHomePageProducts" role="img" aria-label="${name}">
                <a href="${link}">
                    <img width="300" height="300" class="DisplaySearchListingResultFeaturedImage" src="${image1FileName}" alt="${name}" loading="lazy" />
                    <div class="box-up">${name}</div>
                      <div class="box-down">

                <div class="Trending-star-rating-container">
                    <span id="RatingSpan" class="ActualProduct-rating">
                    ${builtRatingStars}
                      </span>
                </div>
                

                    <div class="ProductItem-price-and-moq-wrapper">
                        <div class="ProductItem-price">${price} / ${abvSingle}</div>
                        <div class="ProductItem-moq">MOQ ${moq}</div>
                    </div>
                     </div>
                </a>
            </div>
            `;
    }

    // console.log("✅ BasicProductCard built successfully.");

    // Register event listeners (if any needed in future)
    //  registerEventListenerToAttach(attachEventListenersBasicProductCard);

    return html;
  } catch (err) {
    console.error('❌ Error building BasicProductCard:', err);
    return '<div>Error loading product card</div>';
  }
}

/**
 * Attaches event listeners to the Basic Product Card component
 */
function attachEventListenersBasicProductCard() {
  try {
    // Attach event listeners if needed in the future
    console.log('✅ BasicProductCard event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to BasicProductCard:', error);
  }
}

function renderStarRating(customerRating) {
  const baseURL = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/star/`;
  const fullStar = `${baseURL}star-48.png`;
  const emptyStar = `${baseURL}star-o-48.png`;
  const maxStars = 5;

  // Calculate number of full and empty stars
  const fullStarsCount = Math.min(Math.max(Math.floor(customerRating), 0), maxStars); // Ensure between 0 and 5
  const emptyStarsCount = maxStars - fullStarsCount;

  // Generate the star HTML
  const fullStarsHtml = Array(fullStarsCount)
    .fill(
      `<img src="${fullStar}" width="18" height="18" loading="lazy" alt="" style="width:18px;height:18px;">`
    )
    .join('');
  const emptyStarsHtml = Array(emptyStarsCount)
    .fill(
      `<img src="${emptyStar}" width="18" height="18" loading="lazy" alt="" style="width:18px;height:18px;">`
    )
    .join('');

  // Combine the full and empty stars
  return `${fullStarsHtml}${emptyStarsHtml}`;
}
